import { api } from '@/api';
import {
  GetTaskItemAreaDataTemplateDtoTypeEnum,
  TaskItemAreaDataDto,
  TaskTypeDescription,
} from '@/api/generator';
import { hasTaskItemAreaData } from './setupParameterRules';

/**
 * Loads the task type specific area data template (e.g. the beam analysis corrections)
 * for a new target area. Resolves to `undefined` for task types without area data, so
 * the backend is not asked for a template it rejects, and on a failed request, which the
 * API middleware already reports; the backend validation catches the missing data on save.
 */
export async function getTaskItemAreaDataTemplate(
  taskType: TaskTypeDescription | null | undefined,
): Promise<TaskItemAreaDataDto | undefined> {
  if (!taskType || !hasTaskItemAreaData(taskType)) {
    return undefined;
  }

  const { result, success } = await api.taskItemsApi.getTaskItemAreaDataTemplate({
    getTaskItemAreaDataTemplateDto: {
      taskType,
      $type:
        GetTaskItemAreaDataTemplateDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoGetTaskItemAreaDataTemplateDtoPtwPtw100AppZeroApplicationShared,
    },
  });

  return success ? result : undefined;
}
